<template>
     <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Revertir cancelación
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="12">
              <center> 
                <h6>¿Seguro que deseas revertir la cancelación?</h6>
              </center>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="close">
              Cancelar
            </vs-button>
            <vs-button block success @click="postMultiplesAcciones()">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
    ],
    data () {
        return {
            active: false,
        }
    },
    methods: {
      async postMultiplesAcciones () {
        const loading = this.$vs.loading()
        try {
          const params = {
            movimiento_id: this.row.movimiento_id,
            tipo_store: 'revertir_cancelacion'
          }
          const response = await profesor.postMultiplesAcciones(params)
          loading.close()
          this.$vs.notification({
              progress: 'auto',
              color: 'success',
              position: null,
              title: 'Operación éxitosa.'
          })
          this.$emit('refreshTable',true)
          this.active = false
        } catch(error) {
            loading.close()
            console.log(error)
            this.$vs.notification({
                progress: 'auto',
                color: 'danger',
                position: null,
                title: 'Hubo un error',
                text: 'Favor de contactar al administrador.'
            })
        }
      },
      async close () {
        this.active = false
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>